'use client';

import type { ReactNode } from 'react';

interface DemoInboxProps {
  children: ReactNode;
  label?: string;
  filteredCount?: number;
  className?: string;
}

export function DemoInbox({ children, label, filteredCount, className = '' }: DemoInboxProps) {
  return (
    <div
      className={`overflow-hidden rounded-xl border border-white/[0.08] bg-white/[0.02] shadow-2xl shadow-black/20 ${className}`}
    >
      <div className="flex items-center justify-between border-b border-white/[0.06] px-4 py-2.5">
        <div className="flex items-center gap-2">
          <div className="flex gap-1.5" aria-hidden="true">
            <div className="h-2.5 w-2.5 rounded-full bg-white/10" />
            <div className="h-2.5 w-2.5 rounded-full bg-white/10" />
            <div className="h-2.5 w-2.5 rounded-full bg-white/10" />
          </div>
          {label && <span className="ml-2 text-sm font-medium text-white/50">{label}</span>}
        </div>
        {filteredCount !== undefined && filteredCount > 0 && (
          <div className="flex items-center gap-1.5 rounded-full bg-green-500/10 px-2.5 py-0.5 text-xs font-medium text-green-400">
            <svg className="h-3 w-3" viewBox="0 0 12 12" fill="none" aria-hidden="true">
              <path
                d="M2 6l3 3 5-5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            {filteredCount} filtered
          </div>
        )}
      </div>

      <div className="flex flex-col gap-0.5 p-2">
        {children}
        {filteredCount !== undefined && filteredCount > 0 && (
          <div className="flex items-center justify-center py-8 text-white/20 text-sm">
            <span>No more emails — {filteredCount} cold outreach filtered</span>
          </div>
        )}
      </div>
    </div>
  );
}
